// Configuración de títulos SEO-friendly para cada ruta de la aplicación
// Formato: "Título de la página | Migro.es"

export const PAGE_TITLES: Record<string, string> = {
  // Páginas públicas
  '/': 'Inicio - Contratación y Pago de Servicios Legales | Migro.es',
  '/clientes': 'Portal de Clientes | Migro.es',
  '/clientes/billing': 'Facturación y Pagos - Portal de Clientes | Migro.es',
  '/clientes/:code': 'Portal de Clientes - Contratación | Migro.es',
  '/expirado': 'Enlace Expirado | Migro.es',
  '/404': 'Página No Encontrada | Migro.es',
  '/privacidad': 'Política de Privacidad | Migro.es',
  '/privacy': 'Privacy Policy | Migro.es',
  '/borrador': 'Borrador PDF | Migro.es',
  '/borrador/individual': 'Borrador Individual | Migro.es',
  '/borrador/duo': 'Borrador Pareja/Duo | Migro.es',
  '/borrador/family': 'Borrador Unidad Familiar | Migro.es',
  '/borrador/linked': 'Borrador Oferta 2x1 | Migro.es',
  '/colaboradores': 'Colaboradores | Migro.es',
  '/colaboradores-agentes': 'Convenio de Colaboración - Agentes de Ventas | Migro.es',
  '/closer': 'Closer | Migro.es',
  '/pili': 'Pili - Asistente IA | Migro.es',
  '/regularizacion': 'Regularización Extraordinaria 2026 - ¿Cumples los requisitos? | Migro.es',
  '/regularizacion-v2': 'Regularización Extraordinaria 2026 | Migro.es',
  
  // Rutas de contratación
  '/contratacion': 'Contratación de Servicios | Migro.es',
  '/contratacion/:code': 'Contratación de Servicios | Migro.es',
  '/hiring': 'Hiring Services | Migro.es',
  '/hiring/:code': 'Contratación de Servicios | Migro.es',
  // Módulo mandato (URI separada)
  '/mandato/:code': 'Mandato con Representación | Migro.es',
  
  // Rutas de autenticación
  '/login': 'Iniciar Sesión | Migro.es',
  '/auth/login': 'Iniciar Sesión - Administración | Migro.es',
  '/auth/login-otp': 'Iniciar Sesión (OTP) - Administración | Migro.es',
  '/contrato-old/login': 'Iniciar Sesión - Contrato | Migro.es',
  
  // Dashboard de contratación
  '/contrato/dashboard': 'Dashboard - Gestión de Contratos | Migro.es',
  '/contrato-old/dashboard': 'Dashboard - Gestión de Contratos | Migro.es',
  
  // Módulo Admin
  '/admin': 'Panel de Administración | Migro.es',
  '/admin/dashboard': 'Dashboard - Panel de Administración | Migro.es',
  '/admin/users': 'Gestión de Usuarios | Migro.es',
  '/admin/users/create': 'Crear Usuario | Migro.es',
  '/admin/audit-logs': 'Logs de Auditoría | Migro.es',
  '/admin/conversations': 'Conversaciones | Migro.es',
  '/admin/call-types': 'Tipos de Llamada | Migro.es',
  '/admin/tracing': 'Dashboard de Tracing - Rendimiento | Migro.es',
  '/admin/approve-hiring-code': 'Aprobar Código de Contratación | Migro.es',
  '/admin/release-free-candidates': 'Liberar Candidatos Libres - Admin | Migro.es',
  '/admin/stripe-search': 'Buscar en Stripe - Admin | Migro.es',
  '/admin/agents': 'Agentes IA - Admin | Migro.es',
  '/admin/agents/new': 'Registrar Agente - Admin | Migro.es',
  '/admin/agents/executions': 'Ejecuciones - Agentes IA | Migro.es',
  '/admin/agents/pipelines': 'Pipelines - Agentes IA | Migro.es',
  '/admin/agents/pipelines/new': 'Crear Pipeline - Admin | Migro.es',
  '/admin/opportunities': 'Gestión de Oportunidades - Admin | Migro.es',
  '/admin/route-permissions': 'Permisos de Rutas - Admin | Migro.es',
  '/admin/voice-studio': 'Voice Studio - Admin | Migro.es',
  '/admin/voice-tts-qa': 'Voice Studio - Admin | Migro.es',
  '/admin/contracts': 'Contratos - Admin | Migro.es',
  '/admin/contracts/create': 'Crear Contrato - Admin | Migro.es',

  // Módulo CRM
  '/crm': 'Dashboard - CRM | Migro.es',
  '/crm/dashboard': 'Dashboard - CRM | Migro.es',
  '/crm/contacts': 'Contactos - CRM | Migro.es',
  '/crm/tasks': 'Tareas - CRM | Migro.es',
  '/crm/notes': 'Notas - CRM | Migro.es',
  '/crm/contacts/new': 'Nuevo Contacto | Migro.es',
  '/crm/contracts': 'Contratos - CRM | Migro.es',
  '/crm/contracts/create': 'Crear Contrato - CRM | Migro.es',
  '/crm/contracts/:code': 'Detalle de Contrato - CRM | Migro.es',
  '/crm/contratos-new': 'Contratos - CRM | Migro.es',
  '/crm/contratos-new/crear': 'Crear Contrato - CRM | Migro.es',
  '/crm/contratos-new/plantillas-anexos': 'Plantillas de Anexos - CRM | Migro.es',
  '/crm/contratos-new/:code': 'Detalle de Contrato - CRM | Migro.es',
  '/crm/leads': 'Leads - CRM | Migro.es',
  '/crm/opportunities': 'Oportunidades - CRM | Migro.es',
  '/crm/appointments': 'Citas - CRM | Migro.es',
  '/crm/appointments/:id': 'Detalle de Cita - CRM | Migro.es',
  '/crm/calendar': 'Calendario Unificado - CRM | Migro.es',
  '/crm/calendar-tasks': 'Calendario de Tareas - CRM | Migro.es',
  '/crm/delegations': 'Delegaciones - CRM | Migro.es',
  '/crm/actions': 'Acciones - CRM | Migro.es',
  '/crm/activity-center': 'Novedades del CRM | Migro.es',
  '/crm/seguimientos': 'Seguimientos — Kanban | Migro.es',
  '/crm/expedientes': 'Expedientes - CRM | Migro.es',
  '/crm/expedientes/new': 'Nuevo Expediente | Migro.es',
  '/crm/call': 'Manejo de Llamadas - CRM | Migro.es',
  '/crm/sesion': 'Sesión de Trabajo - CRM | Migro.es',
  '/crm/journal': 'Diario de Trabajo - CRM | Migro.es',
  '/crm/history': 'Historial - CRM | Migro.es',
  '/crm/grabaciones': 'Grabaciones - CRM | Migro.es',
  '/crm/incidencias': 'Incidencias - CRM | Migro.es',
  '/crm/incidencias/:id': 'Detalle de Incidencia - CRM | Migro.es',
  '/crm/facturas': 'Facturas - CRM | Migro.es',
  '/crm/facturas/:id': 'Detalle de Factura - CRM | Migro.es',
  '/crm/presupuestos': 'Presupuestos - CRM | Migro.es',
  '/crm/presupuestos/:id': 'Detalle de Presupuesto - CRM | Migro.es',
  '/crm/faqs': 'FAQs - CRM | Migro.es',
  '/crm/settings': 'Configuración - CRM | Migro.es',
  '/crm/settings/task-templates': 'Plantillas de Tareas | Migro.es',
  '/crm/settings/custom-fields': 'Campos Personalizados | Migro.es',
  '/crm/settings/delegations': 'Gestión de Delegaciones | Migro.es',
  '/crm/settings/timezone': 'Configuración de Zona Horaria | Migro.es',
  '/crm/settings/migro-signature': 'Firma de Migro - Configuración | Migro.es',
  '/crm/settings/responsables': 'Responsables - Configuración | Migro.es',
  '/crm/settings/pipelines': 'Pipelines - Configuración | Migro.es',
  '/crm/profile': 'Mi Perfil - CRM | Migro.es',
};

/**
 * Obtiene el título de la página basado en la ruta actual
 * @param pathname - La ruta actual (ej: '/crm/contacts/123')
 * @returns El título correspondiente o un título por defecto
 */
export function getPageTitle(pathname: string): string {
  // Buscar coincidencia exacta primero
  if (PAGE_TITLES[pathname]) {
    return PAGE_TITLES[pathname];
  }
  
  // Buscar coincidencia parcial para rutas dinámicas (con parámetros)
  // Ordenar por longitud descendente para priorizar rutas más específicas
  const sortedRoutes = Object.keys(PAGE_TITLES).sort((a, b) => b.length - a.length);
  
  for (const route of sortedRoutes) {
    // Convertir ruta a patrón regex
    // Ej: '/crm/contacts/:id' -> '/crm/contacts/.*'
    const routePattern = route.replace(/:[^/]+/g, '[^/]+');
    const regex = new RegExp(`^${routePattern}$`);
    
    if (regex.test(pathname)) {
      return PAGE_TITLES[route];
    }
  }
  
  if (pathname.startsWith('/mandato/')) {
    return 'Mandato con Representación | Migro.es';
  }
  if (pathname.startsWith('/contratacion/') || pathname.startsWith('/hiring/')) {
    return 'Contratación de Servicios | Migro.es';
  }
  
  if (pathname.startsWith('/crm/contacts/') && pathname.includes('/edit')) {
    return 'Editar Contacto | Migro.es';
  }
  
  if (pathname.startsWith('/crm/contacts/')) {
    return 'Detalle de Contacto | Migro.es';
  }
  
  if (pathname.startsWith('/crm/leads/')) {
    return 'Detalle de Lead | Migro.es';
  }
  
  if (pathname.startsWith('/crm/opportunities/')) {
    return 'Detalle de Oportunidad | Migro.es';
  }
  
  if (pathname.startsWith('/crm/tasks/')) {
    return 'Detalle de Tarea | Migro.es';
  }
  
  if (pathname.startsWith('/crm/expedientes/')) {
    return 'Detalle de Expediente | Migro.es';
  }
  
  if (pathname.startsWith('/admin/users/') && pathname !== '/admin/users/create') {
    return 'Detalle de Usuario | Migro.es';
  }
  
  if (pathname.startsWith('/crm/contracts/') && !pathname.endsWith('/create')) {
    return 'Detalle de Contrato | Migro.es';
  }
  
  if (pathname.startsWith('/admin/conversations/')) {
    return 'Detalle de Conversación | Migro.es';
  }
  if (pathname.startsWith('/admin/agents/')) {
    if (pathname.includes('/execute')) return 'Ejecutar Agente | Migro.es';
    if (pathname.includes('/executions')) return 'Ejecuciones | Migro.es';
    if (pathname.includes('/pipelines/runs/')) return 'Detalle de Ejecución Pipeline | Migro.es';
    if (pathname.includes('/pipelines/') && pathname.includes('/run')) return 'Ejecutar Pipeline | Migro.es';
    if (pathname.includes('/pipelines/')) return 'Detalle de Pipeline | Migro.es';
    if (pathname.includes('/edit')) return 'Editar Agente | Migro.es';
    return 'Detalle de Agente | Migro.es';
  }

  // Título por defecto
  return 'Migro.es - Contratación y Pago de Servicios Legales';
}


